/**
 * Stable, machine-readable error codes. The client maps these to human copy
 * (`features/../errorCopy.ts`); it never parses a message string.
 */
export const ERROR_CODES = [
    // transport / generic
    'BAD_REQUEST',
    'VALIDATION_FAILED',
    'UNAUTHORIZED',
    'TOKEN_EXPIRED',
    'FORBIDDEN',
    'NOT_FOUND',
    'RATE_LIMITED',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    // idempotency
    'IDEMPOTENCY_KEY_REQUIRED',
    'IDEMPOTENCY_KEY_REUSED',
    'REQUEST_IN_FLIGHT',
    // auth
    'INVALID_INIT_DATA',
    'INIT_DATA_EXPIRED',
    'USER_SUSPENDED',
    'DEVICE_IN_USE',
    'DEVICE_REQUIRED',
    'IP_IN_USE',
    'IP_BANNED',
    'ACCOUNT_UNDER_REVIEW',
    'DEV_LOGIN_DISABLED',
    // miners / mining
    'MINER_NOT_FOUND',
    'MINER_LOCKED',
    'MINER_ALREADY_WORKING',
    'MINER_CLAIM_PENDING',
    'SHIFT_NOT_FOUND',
    'SHIFT_NOT_READY',
    'SHIFT_ALREADY_CLAIMED',
    'NOTHING_TO_CLAIM',
    // ads
    'AD_SESSION_NOT_FOUND',
    'AD_SESSION_EXPIRED',
    'AD_NONCE_MISMATCH',
    'AD_VERIFICATION_FAILED',
    'AD_NOT_CLICKED',
    'AD_CLICK_TOO_SHORT',
    'CHANNEL_REQUIRED',
    'AD_EVENT_ALREADY_CONSUMED',
    'AD_TOO_FAST',
    'AD_PROVIDER_UNAVAILABLE',
    'AD_CONFIRMATION_PENDING',
    'AD_DAILY_LIMIT',
    // A reward paid only after a rewarded ad: collect it through an ad session.
    'AD_REQUIRED',
    // An ad slot of the task centre: too soon after the last ad, or switched off.
    'AD_COOLDOWN',
    'AD_SLOT_OFF',
    // the human check before a shift (Cloudflare Turnstile)
    'CAPTCHA_REQUIRED',
    'CAPTCHA_FAILED',
    'CAPTCHA_UNAVAILABLE',
    // tasks
    'TASK_NOT_FOUND',
    'TASK_NOT_AVAILABLE',
    'TASK_ALREADY_COMPLETED',
    'TASK_NOT_STARTED',
    'TASK_DWELL_TOO_SHORT',
    'TASK_VERIFICATION_FAILED',
    'TASK_PENDING_REVIEW',
    // daily check-in
    'CHECKIN_ALREADY_CLAIMED',
    'COMBO_ALREADY_SOLVED',
    'COMBO_NO_ATTEMPTS',
    'COMBO_INVALID_PICK',
    // An ad for the combo's reward before the combo was cracked.
    'COMBO_NOT_SOLVED',
    'ROULETTE_NO_SPINS',
    // referrals
    'REFERRAL_CODE_INVALID',
    'REFERRAL_SELF',
    'REFERRAL_ALREADY_SET',
    // wallet / withdrawals
    'INSUFFICIENT_BALANCE',
    'WITHDRAWAL_ALREADY_OPEN',
    'WITHDRAWAL_COOLDOWN',
    'WITHDRAWAL_MINERS_REQUIRED',
    'WITHDRAWAL_BELOW_MINIMUM',
    'WITHDRAWAL_ABOVE_MAXIMUM',
    'WITHDRAWAL_NOT_FOUND',
    'WITHDRAWAL_NOT_CANCELLABLE',
    'INVALID_ADDRESS',
    'UNSUPPORTED_ASSET',
    'UNSUPPORTED_NETWORK',
    'WITHDRAWALS_PAUSED',
    'WITHDRAWAL_INVALID_TRANSITION',
    // swaps
    'SWAP_DISABLED',
    'SWAP_BELOW_MINIMUM',
    'SWAP_TOO_SMALL',
    'SWAP_ASSET_UNKNOWN',
    // deposits
    'DEPOSIT_UNAVAILABLE',
    'DEPOSIT_DUPLICATE',
    'DEPOSIT_NOT_FOUND',
    'DEPOSIT_NOT_REVIEWABLE',
    'DEPOSIT_TOO_MANY_PENDING',
    // saved addresses
    'ADDRESS_NOT_FOUND',
    'ADDRESS_LIMIT_REACHED',
    'ADDRESS_LOCKED',
    // Admin panel
    'CONFLICT',
    'ADMIN_USERNAME_TAKEN',
    'MAINTENANCE_MODE',
];
//# sourceMappingURL=errors.js.map